import { render, staticRenderFns } from "./AccountUncBB.vue?vue&type=template&id=35db078d&"
import script from "./AccountUncBB.vue?vue&type=script&lang=js&"
export * from "./AccountUncBB.vue?vue&type=script&lang=js&"
import style0 from "./AccountUncBB.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports